var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepNoneGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3363_2898)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1685 23.7983L26.4158 14.4459C26.7282 14.1299 27.2375 14.1271 27.5534 14.4394C27.5556 14.4416 27.5577 14.4437 27.5599 14.4459C27.8768 14.7664 27.8768 15.2824 27.5599 15.603L17.7716 25.5025C17.7141 25.5606 17.65 25.6081 17.5816 25.645C17.2731 25.8352 16.8635 25.7978 16.5944 25.5317C16.5922 25.5296 16.5901 25.5274 16.588 25.5253L12.393 21.2827C12.076 20.9621 12.076 20.4461 12.393 20.1256C12.7054 19.8096 13.2147 19.8068 13.5307 20.1191C13.5328 20.1213 13.535 20.1234 13.5371 20.1256L17.1685 23.7983Z",
    fill: "#726551",
    fillOpacity: 0.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#726551",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3363_2898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNoneGray);
export default __webpack_public_path__ + "static/media/step-none-gray.057d8c4072f68669f2174a7da0835392.svg";
export { ForwardRef as ReactComponent };